import React from 'react';
import { NewWay } from './new-way/NewWay';
import { Testimonials } from './testimonials/Testimonials';
import { SearchDifferent } from './SearchDifferent';
import {
  KeyInformation,
  TailoredSearch,
  WinningStrategy,
} from './presentation-banner';

export class DoctrinePresentation extends React.Component<{}> {
  render() {
    return (
      <>
        <NewWay />
        <Testimonials />
        <SearchDifferent />
        <KeyInformation />
        <WinningStrategy />
        <TailoredSearch />
      </>
    );
  }
}
